module.exports = __webpack_public_path__ + "img/723bf17.jpg";